import type React from "react";
import StepEmailNotarySection from "./StepEmailNotarySection";

type Props = {
	showIdNotNotaryBlock: boolean;
	notaryTitle: string;
	notaryCta: string;
	notarySubscribeCta: string;
	onNotaryConnect: () => void;
};

export default function StepEmailProAuthBlocks(props: Props): React.JSX.Element {
	const { showIdNotNotaryBlock, notaryTitle, notaryCta, notarySubscribeCta, onNotaryConnect } = props;

	if (!showIdNotNotaryBlock) {
		return <></>;
	}

	return (
		<StepEmailNotarySection
			title={notaryTitle}
			cta={notaryCta}
			subscribeCta={notarySubscribeCta}
			onClick={onNotaryConnect}
		/>
	);
}
